module.exports = __webpack_public_path__ + "img/9788954436915.159adcbb.jpg";